export default class OtpLogin {
    constructor() {
        if (!$('#otp-login-form').length) return;

        this.currentEmail = '';
        this.$emailInput = $('#otp-email');
        this.$otpInput = $('#otp-code');
        this.$emailError = $('#email-error');
        this.$otpError = $('#otp-error');
        this.$requestBtn = $('#request-otp-btn');
        this.$verifyBtn = $('#verify-otp-btn');
        this.$editEmailLink = $('#edit-email-link');
        this.$otpCodeField = $('#otp-code-field');

        this.initEvents();
    }

    initEvents() {
        this.$requestBtn.on('click', this.handleOtpRequest.bind(this));
        this.$editEmailLink.on('click', this.handleEditEmail.bind(this));
        this.$verifyBtn.on('click', this.handleOtpVerify.bind(this));
    }

    handleOtpRequest() {
        const email = this.$emailInput.val().trim();
        if (!this.isValidEmail(email)) {
            this.showError(this.$emailError, pitpatOtpVars.i18n.invalid_email);
            return;
        }

        this.clearErrors();
        this.setButtonLoading(this.$requestBtn, true);

        $.post(pitpatOtpVars.ajax_url, {
            action: 'pitpat_send_otp',
            email: email,
            nonce: pitpatOtpVars.nonce
        })
        .done(() => {
            this.currentEmail = email;
            this.$emailInput.prop('readonly', true);
            this.$editEmailLink.fadeIn();
            this.$otpCodeField.fadeIn();
            this.$requestBtn.hide();
            this.$verifyBtn.show();
            this.showSuccess(this.$emailError, pitpatOtpVars.i18n.otp_sent);
        })
        .fail(xhr => {
            const errorMsg = xhr.responseJSON?.data?.message || pitpatOtpVars.i18n.otp_error;
            this.showError(this.$emailError, errorMsg);
        })
        .always(() => {
            this.setButtonLoading(this.$requestBtn, false);
        });
    }

    handleEditEmail(e) {
        e.preventDefault();
        this.$emailInput.prop('readonly', false).focus();
        this.$editEmailLink.fadeOut();
        this.$otpCodeField.fadeOut();
        this.$otpInput.val('');
        this.$requestBtn.show();
        this.$verifyBtn.hide();
        this.clearErrors();
    }

    handleOtpVerify() {
        const otp = this.$otpInput.val().trim();
        if (otp.length !== 6) {
            this.showError(this.$otpError, 'Please enter a valid 6-digit code');
            return;
        }

        this.clearErrors();
        this.setButtonLoading(this.$verifyBtn, true);

        $.post(pitpatOtpVars.ajax_url, {
            action: 'pitpat_verify_otp',
            email: this.currentEmail,
            otp: otp,
            nonce: pitpatOtpVars.nonce
        })
        .done(response => {
            if (response.success && response.data.redirect) {
                window.location.href = response.data.redirect;
            } else {
                const errorMsg = response.data?.message || pitpatOtpVars.i18n.verify_error;
                this.showError(this.$otpError, errorMsg);
            }
        })
        .fail(xhr => {
            const errorMsg = xhr.responseJSON?.data?.message || pitpatOtpVars.i18n.verify_error;
            this.showError(this.$otpError, errorMsg);
        })
        .always(() => {
            this.setButtonLoading(this.$verifyBtn, false);
        });
    }

    isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    setButtonLoading($button, isLoading) {
        $button.prop('disabled', isLoading);
        if (isLoading) {
            $button.data('original-text', $button.text());
            $button.html('<span class="spinner" style="margin-right:8px;"></span>' + pitpatOtpVars.i18n.loading);
        } else {
            $button.html($button.data('original-text'));
        }
    }

    showError($element, message) {
        $element.text(message).addClass('woocommerce-error').fadeIn();
    }

    showSuccess($element, message) {
        $element.text(message).removeClass('woocommerce-error').addClass('woocommerce-message').fadeIn();
    }

    clearErrors() {
        this.$emailError.fadeOut().removeClass('woocommerce-error woocommerce-message');
        this.$otpError.fadeOut().removeClass('woocommerce-error woocommerce-message');
    }
}